/**
 * ClosingCTA \u2014 repeat of the primary "Read the Subtext" CTA above the
 * footer (Spec Section 1, Block 7). Same label as the hero \u2014 do NOT
 * introduce a new CTA word here.
 */
import { ArrowRight } from "lucide-react";
import { CLOSING_CTA, ANCHORS } from "../lib/copy";

export const ClosingCTA = ({ onReadSubtext }) => (
  <section
    data-testid="closing-cta-band"
    className="px-5 sm:px-8 py-12 sm:py-16 max-w-3xl mx-auto"
  >
    <div
      className="ss-panel p-7 sm:p-10 text-center"
      style={{ borderColor: "var(--ss-gold)" }}
    >
      <p
        className="ss-display-tight text-2xl sm:text-3xl leading-tight mb-5"
        data-testid="closing-cta-headline"
        style={{ color: "var(--ss-ink)" }}
      >
        {ANCHORS.positioning}
      </p>
      <button
        data-testid="closing-cta-btn"
        onClick={onReadSubtext}
        className="ss-cta ss-cta-mode-primary text-base sm:text-lg px-7 py-4"
      >
        {CLOSING_CTA.label}
        <ArrowRight className="w-5 h-5" strokeWidth={2.25} />
      </button>
    </div>
  </section>
);
